<div class="edit-wizard-book">
  <h3>Confirm Your Book Details</h3>
  <div class="book-details">
    <app-input-form [form]="editBookForm" [id]="bookComponents.title.key" [label]="bookComponents.title.label"
      [type]="bookComponents.title.type" [required]="bookComponents.title.required">
    </app-input-form>

    <app-input-form [form]="editBookForm" [id]="bookComponents.author.key" [label]="bookComponents.author.label"
      [type]="bookComponents.author.type" [required]="bookComponents.author.required">
    </app-input-form>

    <app-textarea-form [form]="editBookForm" [id]="bookComponents.description.key"
    [label]="bookComponents.description.label" [required]="bookComponents.description.required"></app-textarea-form>

    <p class="decription-subtext">Must be 350 characters or less. Please don't copy from Amazon.</p>
    <app-input-form class="promo-wizard-input price" [form]="editBookForm" [id]="bookComponents.promoPrice.key"
      [min]="0"
      [label]="bookComponents.promoPrice.label" [type]="bookComponents.promoPrice.type"
      [required]="bookComponents.promoPrice.required"
      [readonly]="true">
    </app-input-form>

    <app-form-input [input]="bookComponents.kindleUnlimited" [form]="editBookForm"></app-form-input>
    <app-form-input [input]="bookComponents.kindleCountdownDeal" [form]="editBookForm"></app-form-input>

    <app-input-form [form]="editBookForm" [id]="bookComponents.bookLength.key" [label]="bookComponents.bookLength.label"
      [type]="bookComponents.bookLength.type" [required]="bookComponents.bookLength.required"
      [min]="bookComponents.bookLength.min">
    </app-input-form>

    <app-form-input [input]="bookComponents.isSeries" [form]="editBookForm"></app-form-input>
    @if (editBookForm.value.isSeries === true) {
      <div>
        <h6>Series Info</h6>
        <app-input-form [form]="editBookForm" [id]="bookComponents.nameOfSeries.key"
          [label]="bookComponents.nameOfSeries.label" [type]="bookComponents.nameOfSeries.type"
          [required]="bookComponents.nameOfSeries.required">
        </app-input-form>
        <app-input-form [form]="editBookForm" [id]="bookComponents.numberOfBooksInSeries.key"
          [label]="bookComponents.numberOfBooksInSeries.label" [type]="bookComponents.numberOfBooksInSeries.type"
          [required]="bookComponents.numberOfBooksInSeries.required" [min]="bookComponents.numberOfBooksInSeries.min">
        </app-input-form>
        <app-input-form [form]="editBookForm" [id]="bookComponents.bookNumber.key" [label]="bookComponents.bookNumber.label"
          [type]="bookComponents.bookNumber.type" [required]="bookComponents.bookNumber.required"
          [min]="bookComponents.bookNumber.min">
        </app-input-form>
      </div>
    }
  </div>

  <div class="book-cover">
    <app-file-drop [bookUrl]="book ? book.amazonImageUrl : defaultCoverImage"
      (loading)="isUploadingBookCover($event)" (bookUploadData)="bookCoverUpload($event)"
      (bookUploadError)="bookCoverUploadError($event)">
    </app-file-drop>

    @if (uploadError) {
      <div>{{uploadError}}</div>
    }

    @if (uploading) {
      <app-spinner label="Uploading"></app-spinner>
    }
  </div>

  <div style="clear: both;"></div>

  <h6>Links</h6>
  <app-input-form [form]="editBookForm" [id]="bookComponents.amazonLink.key" [label]="bookComponents.amazonLink.label"
    [type]="bookComponents.amazonLink.type" [required]="bookComponents.amazonLink.required">
  </app-input-form>

  <div id="{{ bookComponents.apple.key+'_field' }}" class="toggle-input">
    <div class="toggle-input-wrap">
      <app-input-form [form]="editBookForm" [id]="bookComponents.apple.key" [label]="bookComponents.apple.label"
        [type]="bookComponents.apple.type" [required]="bookComponents.apple.required">
      </app-input-form>

      <span class="deleteButton" (click)="deleteInput(bookComponents.apple.key)">
        &#10006;
      </span>
    </div>
  </div>

  <div id="{{ bookComponents.nook.key+'_field' }}" class="toggle-input">
    <div class="toggle-input-wrap">
      <app-input-form [form]="editBookForm" [id]="bookComponents.nook.key" [label]="bookComponents.nook.label"
        [type]="bookComponents.nook.type" [required]="bookComponents.nook.required">
      </app-input-form>

      <span class="deleteButton" (click)="deleteInput(bookComponents.nook.key)">
        &#10006;
      </span>
    </div>
  </div>

  <div id="{{ bookComponents.kobo.key+'_field' }}" class="toggle-input">
    <div class="toggle-input-wrap">
      <app-input-form [form]="editBookForm" [id]="bookComponents.kobo.key" [label]="bookComponents.kobo.label"
        [type]="bookComponents.kobo.type" [required]="bookComponents.kobo.required">
      </app-input-form>

      <span class="deleteButton" (click)="deleteInput(bookComponents.kobo.key)">
        &#10006;
      </span>
    </div>
  </div>

  <div id="{{ bookComponents.googleplay.key+'_field' }}" class="toggle-input">
    <div class="toggle-input-wrap">
      <app-input-form [form]="editBookForm" [id]="bookComponents.googleplay.key" [label]="bookComponents.googleplay.label"
        [type]="bookComponents.googleplay.type" [required]="bookComponents.googleplay.required">
      </app-input-form>

      <span class="deleteButton" (click)="deleteInput(bookComponents.googleplay.key)">
        &#10006;
      </span>
    </div>
  </div>

  <div class="link-box">
    <ng-select [items]="linkTypes"
      bindLabel="label" class="value" bindValue="value" groupBy="type" [hideSelected]="false"
      (change)="addInput($event.value)" placeholder="Add Another Link">
      <ng-template ng-optgroup-tmp let-item="item" let-index="index">
        <div>SELECT LINK TYPE</div>
      </ng-template>
    </ng-select>
  </div>

  <div class="flex">
    <div class="terms">
      <div [formGroup]="editBookForm">
        <input
          id="terms"
          [value]="editBookForm.value.terms"
          type="checkbox"
          formControlName="terms"
          class="form-control left"
          >
      </div>

      By checking this box, you agree to Written Word Media's
      <a href = 'https://www.writtenwordmedia.com/terms' target="_blank">Terms of Service</a> and
      <a href="https://www.writtenwordmedia.com/terms" target="_blank">Privacy Policy</a>
    </div>
  </div>
</div>
